var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    className: "image-svg-svg primary",
    style: {
      overflow: "visible"
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-5 -5 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cryptolab") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.23 74.45a37.23 37.23 0 1 1 0-74.45L67 59.56a37.19 37.19 0 0 1-29.77 14.89z",
    fill: "#FF6600",
    opacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.23 0a37.23 37.23 0 1 0 0 74.45L67 14.89A37.19 37.19 0 0 0 37.23 0z",
    fill: "#007AFF",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0e59388d6c2ebcd96eeea0f4f78719b8.svg";
export { ForwardRef as ReactComponent };